import { ReactNode } from 'react';
import { gql } from '@apollo/client';

export type ISession = {
  accessToken: string;
  idToken: string;
  sessionId: string;
};

export type SessionStatusTypes =
  | 'unauthenticated'
  | 'loading'
  | 'authenticated';

export interface SessionContextProviderInterface {
  children: ReactNode;
  session: ISession | null;
}

export type SessionContextTypes = {
  session: ISession | null;
  status: SessionStatusTypes;
};

export enum AuthErrorType {
  INTERNAL_TECHNICAL_ERROR = 'Internal technical error',
}

export const GET_CURRENT_SESSION = gql`
  query getCurrentSession($refresh: Boolean!) {
    getSession(refresh: $refresh) {
      userId
      accessToken
      idToken
      sessionId
      expiresIn
    }
  }
`;
